import { AskGregSection } from './AskGreqSection';
import { AskGregSectionBlock } from './ask-greg-section.types';

interface AskGregSectionRendererProps {
  block: AskGregSectionBlock;
}

export function AskGregSectionRenderer({ block }: AskGregSectionRendererProps) {
  if (!block || typeof block !== 'object' || block.isEnabled === false) {
    return null;
  }
  const quickPrompts = Array.isArray(block?.prompts)
    ? block.prompts.filter((text) => text && text.trim() !== '').map((text) => ({ text }))
    : [];

  return (
    <AskGregSection
      title={block?.heading || undefined}
      description={block?.description || undefined}
      quickPromptsTitle={block?.subheading || undefined}
      quickPrompts={quickPrompts}
      isShowButton={block?.isShowButton ?? true}
      backgroundColor={block?.backgroundColor ?? undefined}
    />
  );
}
